import {
  ADD_COMPLEMENT_REQUEST_APPROVAL,
  ADD_COMPLEMENT_REQUEST_APPROVAL_START,
  ADD_COMPLEMENT_REQUEST_APPROVAL_ERROR,
  GET_COMPLEMENT_REQUEST_APPROVAL_LAST,
  GET_COMPLEMENT_REQUEST_APPROVAL_LAST_START,
  GET_COMPLEMENT_REQUEST_APPROVAL_LAST_ERROR,
  GET_COMPLEMENT_REQUEST_APPROVAL_LIST_BY_REQUEST,
  GET_COMPLEMENT_REQUEST_APPROVAL_LIST_BY_REQUEST_START,
  GET_COMPLEMENT_REQUEST_APPROVAL_LIST_BY_REQUEST_ERROR,
  CLEAR_COMPLEMENT_REQUEST_APPROVAL,
} from '../actions/types';

const initialState = {
  complementRequestApprovalList: [],
  complementRequestApproval: {},
  loading: false,
  error: undefined,
  totalElements: '',
};

const clearComplementRequestApproval = (state) => {
  return {
    ...state,
    complementRequestApproval: {},
  };
};

const addComplementRequestApprovalStart = (state) => {
  return {
    ...state,
    loading: true,
    error: undefined,
  };
};

const addComplementRequestApprovalError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const addComplementRequestApproval = (state, action) => {
  return {
    ...state,
    loading: false,
    complementRequestApproval: action.payload,
    complementRequestApprovalList: state.complementRequestApprovalList.concat([
      action.payload,
    ]),
    error: undefined,
  };
};

const getLastComplementRequestApprovalByRequestStart = (state) => {
  return {
    ...state,
    loading: true,
    error: undefined,
  };
};

const getLastComplementRequestApprovalByRequestError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const getLastComplementRequestApprovalByRequest = (state, action) => {
  return {
    ...state,
    loading: false,
    complementRequestApproval: action.payload,
    error: undefined,
  };
};

const getComplementRequestApprovalListByRequestStart = (state) => {
  return {
    ...state,
    loading: true,
    error: undefined,
  };
};

const getComplementRequestApprovalListByRequestError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const getComplementRequestApprovalListByRequest = (state, action) => {
  return {
    ...state,
    loading: false,
    complementRequestApprovalList: action.payload,
    error: undefined,
  };
};

export default function (state = initialState, action) {
  switch (action.type) {
    case ADD_COMPLEMENT_REQUEST_APPROVAL:
      return addComplementRequestApproval(state, action);
    case ADD_COMPLEMENT_REQUEST_APPROVAL_START:
      return addComplementRequestApprovalStart(state);
    case ADD_COMPLEMENT_REQUEST_APPROVAL_ERROR:
      return addComplementRequestApprovalError(state, action);

    case GET_COMPLEMENT_REQUEST_APPROVAL_LAST:
      return getLastComplementRequestApprovalByRequest(state, action);
    case GET_COMPLEMENT_REQUEST_APPROVAL_LAST_START:
      return getLastComplementRequestApprovalByRequestStart(state);
    case GET_COMPLEMENT_REQUEST_APPROVAL_LAST_ERROR:
      return getLastComplementRequestApprovalByRequestError(state, action);

    case GET_COMPLEMENT_REQUEST_APPROVAL_LIST_BY_REQUEST:
      return getComplementRequestApprovalListByRequest(state, action);
    case GET_COMPLEMENT_REQUEST_APPROVAL_LIST_BY_REQUEST_START:
      return getComplementRequestApprovalListByRequestStart(state);
    case GET_COMPLEMENT_REQUEST_APPROVAL_LIST_BY_REQUEST_ERROR:
      return getComplementRequestApprovalListByRequestError(state, action);

    case CLEAR_COMPLEMENT_REQUEST_APPROVAL:
      return clearComplementRequestApproval(state);

    default:
      return state;
  }
}
